import { TableConfig } from '@shared/interfaces/table/table-config';
import { LinkCellComponent } from '@shared/components/table/cells/link-cell/link-cell.component';
import { MeteringPointQueryResultDto } from '@app/api/dmc';
import { meteringPointTypePartial } from '@shared/partials/meteringpointtype-partial.table';
import { datahubPartial } from '@shared/partials/datahub.partial';
import { isChildPartial } from '@shared/partials/isChildPartial';
import { physicalStatusPartial } from '@shared/partials/physicalstatus.partial';
import { settlementmethodPartial } from '@shared/partials/settlementmethod.partial';
import { hasBalanceSupplierPartial } from '@shared/partials/has-balance-supplier.partial';
import { addressPartial, isMeterActivePartial, meterNumberPartial } from '@shared/columns/meteringpoint.columns';
import { existsInDatahub } from '@shared/partials/existsindatahub.partial';

export const meteringPointTable: TableConfig<MeteringPointQueryResultDto> = {
  id: 'meteringpoint-list',
  title: 'meteringpoint.title',
  floatingHeader: true,
  exportable: true,
  copyable: true,
  selectable: true,
  selectableType: 'single',
  columnSelection: true,
  reorder: true,
  saveChanges: true,
  pageSize: 25,
  pageSizeSelection: true,
  columns: [
    {
      title: 'meter.id',
      key: 'identification',
      width: 195,
      cellRenderer: LinkCellComponent,
      cellRendererParams: {
        url: '/meteringpoint',
        urlReference: 'identification',
      }
    },
    addressPartial,
    settlementmethodPartial,
    meteringPointTypePartial,
    physicalStatusPartial,
    meterNumberPartial,
    isMeterActivePartial,
    datahubPartial,
    hasBalanceSupplierPartial,
    isChildPartial,
    existsInDatahub,
  ]
}
